import { useState, ChangeEvent, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import wordmark from '../assets/brand/wordmark-light.png';
import './Landing.css';

const CONTACT_EMAIL = 'zengdigital8@gmail.com';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', gym: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const set = (key: keyof typeof form) => (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const subject = `Contact — ${form.gym || form.name}`;
    const body = [
      `Name: ${form.name}`,
      `Email: ${form.email}`,
      form.gym && `Gym / studio: ${form.gym}`,
      `\n${form.message}`,
    ]
      .filter(Boolean)
      .join('\n');
    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setSubmitted(true);
  };

  return (
    <div className="lp">
      {/* NAV */}
      <nav className="top">
        <div className="inner">
          <Link className="logo" to="/"><img src={wordmark} alt="Porrada" /></Link>
          <div className="nav-cta">
            <Link className="btn btn-ghost" to="/login">Sign in</Link>
          </div>
        </div>
      </nav>

      <section className="demo">
        <div className="container">
          <span className="label section-eyebrow">— Contact</span>
          <h1>Let's talk.</h1>
          <p className="section-sub">
            Custom plans, bigger academies, questions the site doesn't answer —
            tell us what you need and we'll get back to you within one business day.
          </p>

          <div className="demo-grid">
            {submitted ? (
              <div className="demo-success">
                <span className="label">— Message drafted</span>
                <h3>One more step.</h3>
                <p>
                  Your email app should have opened with your message ready to send.
                  Hit send and we'll get back to you within one business day.
                </p>
                <p>
                  Nothing opened? Email us directly at{' '}
                  <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
                </p>
                <button className="btn btn-ghost" onClick={() => setSubmitted(false)}>Edit my message</button>
              </div>
            ) : (
              <form className="demo-form" onSubmit={handleSubmit}>
                <div className="demo-row2">
                  <label>
                    Your name
                    <input type="text" value={form.name} onChange={set('name')} placeholder="Alex Morgan" required />
                  </label>
                  <label>
                    Email
                    <input type="email" value={form.email} onChange={set('email')} placeholder="alex@yourgym.com" required />
                  </label>
                </div>
                <label>
                  <span>Gym / studio name <span className="demo-opt">· optional</span></span>
                  <input type="text" value={form.gym} onChange={set('gym')} placeholder="Northside BJJ" />
                </label>
                <label>
                  What do you need?
                  <textarea
                    value={form.message}
                    onChange={set('message')}
                    placeholder="Three locations, ~450 members, we'd need a gym website and unlimited staff accounts…"
                    required
                  />
                </label>
                <button className="btn btn-primary btn-lg" type="submit">Send Message</button>
              </form>
            )}

            <aside className="demo-aside">
              <h4 className="label">— Good to know</h4>
              <ul>
                <li>
                  <span className="demo-num">01</span>
                  <div>
                    <strong>Custom means custom</strong>
                    <p>Tailor-made plans are priced by scope — member count, locations, staff seats, and anything extra like a gym website.</p>
                  </div>
                </li>
                <li>
                  <span className="demo-num">02</span>
                  <div>
                    <strong>One business day</strong>
                    <p>That's our reply time. The more you tell us about your setup, the faster we can put a real number in front of you.</p>
                  </div>
                </li>
                <li>
                  <span className="demo-num">03</span>
                  <div>
                    <strong>Rather see it first?</strong>
                    <p><Link to="/book-demo">Book a demo</Link> and we'll walk you through the whole platform before talking plans.</p>
                  </div>
                </li>
              </ul>
              <p className="demo-alt">
                Prefer email? Write to us at <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
              </p>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
}
